import * as Constants from "../../config/constants/Constants.js";
import { getLanguage } from "../../config/language/language.js";
import { getFetch, postFetch, catchAPIResponse, catchAPIError } from "./http.js";
import { sessionExpired } from "./authQueries.js";
import { normalizeVenue } from "../shared/guestPrefs.js";

const menuPath = (venue, { refresh = false } = {}) => {
    const resolved = normalizeVenue(venue);
    const base = refresh ? Constants.API_ADMIN_MENU_REFRESH : Constants.API_MENU;
    return resolved ? `${base}?venue=${encodeURIComponent(resolved)}` : base;
};

const detailFromResponse = (response) => {
    const detail = response?.body?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
    return null;
};

export const queryMenu = (props, venueOverride) => {
    const venue = venueOverride ?? props.prefs?.guestPrefs?.venue;
    props.menu.setMenuError?.(null);
    getFetch(menuPath(venue), props.user.userJWT)
        .then((response) => {
            if (response.ok) {
                props.menu.setMenuData(response.body);
                props.menu.setMenuError?.(null);
            } else {
                props.menu.setMenuError?.({
                    status: response.status,
                    detail: detailFromResponse(response),
                });
                catchAPIResponse(props, response, {
                    onUnauthorized: () => sessionExpired(props),
                });
            }
        })
        .catch((err) => {
            props.menu.setMenuError?.({ status: 0, detail: null });
            catchAPIError(props, err);
        });
};

/** Admin: force-refresh menu cache from Google Sheets. */
export const refreshMenuFromSheets = async (props, venue) => {
    const path = menuPath(venue ?? props.prefs?.guestPrefs?.venue, { refresh: true });
    const response = await postFetch(path, {}, props.user.userJWT);
    if (!response.ok) {
        catchAPIResponse(props, response, {
            onUnauthorized: () => sessionExpired(props),
        });
        return null;
    }
    props.menu.setMenuData(response.body);
    props.menu.setMenuError?.(null);
    props.showSnackbar?.({
        color: "success",
        message: getLanguage().SNACKBAR_SUCCESS_MENU_REFRESH,
    });
    return response.body;
};

/** Admin: fetch plain-text menu + stock export for clipboard. */
export const exportMenuData = async (props, venue) => {
    const resolved = normalizeVenue(venue);
    const path = resolved
        ? `${Constants.API_ADMIN_MENU_EXPORT}?venue=${encodeURIComponent(resolved)}`
        : Constants.API_ADMIN_MENU_EXPORT;
    const response = await getFetch(path, props.user.userJWT);
    if (!response.ok) {
        catchAPIResponse(props, response, {
            onUnauthorized: () => sessionExpired(props),
        });
        return null;
    }
    return response.body;
};
